{
  "de": {
    "published": {
      "labels": {
        "notPublished": "Nicht veröffentlicht",
        "publishedCustomer": "Veröffentlicht für Kunden",
        "publishedCustomerPartners": "Veröffentlicht für Kunden & Partner",
        "publishedPartners": "Veröffentlicht für Partner"
      },
      "publish_mode": {
        "inherit": "Vorlage folgen",
        "inherit_info": "Behält den veröffentlichten oder unveröffentlichten Status jedes Elements aus der Vorlage bei",
        "publish": "Für Kunden veröffentlichen",
        "publish_info": "Kunden können diese sofort sehen",
        "title": "Veröffentlichung",
        "unpublished": "Ohne Veröffentlichung erstellen",
        "unpublished_info": "Für Kunden verborgen, bis Sie sie veröffentlichen"
      }
    }
  }
}
